import { render, staticRenderFns } from "./livepicmanage.vue?vue&type=template&id=dea977ce&scoped=true&"
import script from "./livepicmanage.vue?vue&type=script&lang=js&"
export * from "./livepicmanage.vue?vue&type=script&lang=js&"
import style0 from "./livepicmanage.vue?vue&type=style&index=0&id=dea977ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea977ce",
  null
  
)

export default component.exports